import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { getMatchingTickers, getTickerLookup } from "../../../../config/apiConfig";
import { sbaAxios } from '../../../utils/sbaAxios';
import moment from "moment/moment";

export const SecurityLookup = () => {
  const [searchTickerValue, setTickerSearchValue] = useState("");
  const [selectedOption, setSelectedOption] = useState(false);
  const [matchingTickersValue, setMatchingTickersValue] = useState([]);
  const [tickerLookupValue, setTickerLookupValue] = useState([]);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value === 'true');
  };

  const matchingTickerscolumnDefs = [
    {
      field: "Ticker",
      headerName: "Ticker",
    },
  ];

  const TickerLookupcolumnDefs = [
    {
      field: "ManagerName",
      headerName: "Manager Name",
    },
    {
      field: "AssetName",
      headerName: "Asset Name",
    },
    {
      field: "ReportDate",
      headerName: "Report Date",
      valueFormatter: dateFormatter,
    },
    {
      field: "WeightPercOf13f",
      headerName: "Weight Of 13F Filing (Equity only)",
      valueFormatter: percentFormatter,
    },
    {
      field: "MktValue",
      headerName: "MktValue",
      valueFormatter: currencyFormatter,
    },
    {
      field: "Shares",
      headerName: "Shares",
      valueFormatter: numberFormatter,
    },
  ];

  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable:true
  };

  const noRowsOverlayTemplate = `<span class="ag-overlay-no-rows-center">No data found</span>`;

  function percentFormatter(params) {
    const value = parseFloat(params.value);
    if (isNaN(value) || typeof value !== "number") {
      return "N/A";
    }
    const multipliedValue = value * 100;
    return `${multipliedValue.toFixed(2)}%`;
  }

  function dateFormatter(params) {
    if (!params.value) {
      return "N/A";
    }
    const date = moment(params.value);
    return date.format("MM/DD/YYYY");
  }

  function currencyFormatter(params) {
    const value = parseFloat(params.value);
    if (isNaN(value) || typeof value !== "number") {
      return "N/A";
    }    
    const roundedValue = Math.round(value)
    const formattedValue = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(roundedValue);
    
    return formattedValue;
  }

  function numberFormatter(params) {
    const value = parseFloat(params.value);
    if (isNaN(value) || typeof value !== "number") {
      return "N/A";
    }    
    const roundedValue = Math.round(value)
    const formattedValue = new Intl.NumberFormat('en-US', {
      
    }).format(roundedValue);
    
    return formattedValue;
  }
  

  const tickerSearchChange = async (event) => {
    const { value } = event.target;
    setTickerSearchValue(value);

    try {
      let response;
      if (value !== "" && value !== null) {
          response = await sbaAxios({
              url: `${getMatchingTickers}${value}`,
              method: 'get',
          })
        const MatchingTickersData = response;
        setMatchingTickersValue(MatchingTickersData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const matchingTickerRowClick = async (event) => {
    const value = event.data.Ticker;
    try {
      let response;
      if (value !== "" && value !== null) {
          response = await sbaAxios({
              url: `${getTickerLookup}${value},${selectedOption ? '1' : '0'}`,
              method: 'get',
          });
        const TickerLookupData = response;
        setTickerLookupValue(TickerLookupData);
    }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <form action="#">
        <div className="row flex-wrap">
          <div className="col-md-4">
            <label className="mb-1 ms-2 fw-semibold fs-12">Ticker Lookup</label>
            <div>
              <input
                type="text"
                className="form-control"
                value={searchTickerValue}
                onChange={tickerSearchChange}
                placeholder="Search Ticker..."
              />
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="from-date" className="mb-1 ms-2 fw-semibold fs-12">
              Manager Selection
            </label>
            <div>             
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="manager-selection"
                  id="entireUniverse"
                  value="true"
                  onChange={handleRadioChange}
                  defaultChecked={selectedOption === true}
                  disabled={true}
                />
                <label
                  htmlFor="entireUniverse"
                  className="form-check-label"
                >
                  Entire Universe 
                </label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="manager-selection"
                  id="investedUniverse"
                  value="false"
                  onChange={handleRadioChange}
                  defaultChecked={selectedOption === false}
                />
                <label htmlFor="investedUniverse" className="form-check-label">
                  Invested Universe
                </label>
              </div>
            </div>
          </div>

          <div
            className="ag-theme-alpine"
            style={{ width: "100%", height: "250px" }}
          >
            <AgGridReact
              columnDefs={matchingTickerscolumnDefs}
              rowData={matchingTickersValue}
              defaultColDef={defaultColDef}
              gridOptions={{
                overlayNoRowsTemplate: noRowsOverlayTemplate,
              }}
              onRowClicked={matchingTickerRowClick}
            />
          </div>

          <div
            className="ag-theme-alpine"
            style={{ width: "100%", height: "500px" }}
          >
            <AgGridReact
              columnDefs={TickerLookupcolumnDefs}
              rowData={tickerLookupValue}
              defaultColDef={defaultColDef}
              gridOptions={{
                overlayNoRowsTemplate: noRowsOverlayTemplate,
              }}
            />
          </div>
        </div>
      </form>
    </>
  );
};
